/**
 * Employee domain constants
 * Each constant represents a distinct value for the employees domain
 */

export const EmployeeStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
} as const;

/**
 * The channels a notification can travel by.
 *
 * The screen paints both columns for every group; which of them a group actually offers is the
 * backend's answer, not this list.
 */
export const NotificationChannels = {
  WHATSAPP: 'whatsapp',
  EMAIL: 'email',
} as const;

/** The order the two channel columns are painted in. */
export const NOTIFICATION_CHANNEL_ORDER = [NotificationChannels.WHATSAPP, NotificationChannels.EMAIL] as const;

/**
 * The notification groups this application has wording for.
 *
 * The backend publishes the groups and can add one at any time, so this list is not the catalogue:
 * it is the subset that can be painted. A group that arrives without wording here is dropped, since
 * showing its raw identifier would be worse than not showing the row.
 */
export const NotificationGroups = {
  CASH_REGISTER: 'cash_register',
  PAY_DEPOSITS: 'pay_deposits',
  PAYMENTS_SUBSCRIPTION: 'payments_subscription',
  ACCOUNT_SECURITY: 'account_security',
} as const;

/**
 * Whether the backend considers every contact value of an account confirmed.
 *
 * The conjunction of email and phone is resolved by whoever publishes it, never here: a second
 * definition of "verified" would drift from the first.
 */
export const VerificationStatus = {
  VERIFIED: 'verified',
  NOT_VERIFIED: 'not_verified',
} as const;

/**
 * What the administrator is asking for when they submit the user form.
 *
 * The same write serves the three, and the backend decides on its own whether a link goes out. The
 * intent never travels: it names the button, the closing toast and the observability attribute.
 */
export const EmployeeSaveIntents = {
  SAVE: 'save',
  SAVE_AND_INVITE: 'saveAndInvite',
  RESEND_LINK: 'resendLink',
} as const;
